import { ReactNode } from 'react';

export type ListEmptyStateProps = {
  /** Anchor id for the list this stands in for, e.g. `article-list`. */
  id: string;
  title?: string;
  /** e.g. "No news found" */
  message: string;
  hint?: string;
  icon: ReactNode;
};

/**
 * The "nothing matched" state for the article and video listings.
 *
 * Reuses the `article-card-list-container` block, whose `--empty` modifier
 * carries a min-height in every theme. That height matters: without it the
 * container collapses and an open filter dropdown above is clipped by whatever
 * follows the list.
 */
export function ListEmptyState({
  id,
  title,
  message,
  hint = 'Try adjusting your filters or search criteria',
  icon,
}: ListEmptyStateProps) {
  return (
    <div className="article-card-list-container article-card-list-container--empty" id={id}>
      {title && <h3 className="article-card-list-container__title">{title}</h3>}
      <div className="article-card-list-container__empty-state">
        <div className="article-card-list-container__empty-icon">{icon}</div>
        <p className="article-card-list-container__empty-message text-l">{message}</p>
        <p className="article-card-list-container__empty-hint text-s">{hint}</p>
      </div>
    </div>
  );
}
